<template>
  <b-container class="d-flex align-items-center flex-column my-5">
    <b-row class="text">
      {{ title }}
    </b-row>
    <b-row class="d-flex align-items-center w-100">
      <b-col class="d-none d-md-block" cols="2"></b-col>
      <b-col>
        <picture>
          <source
            srcset="https://cdn.vexels.com/img/design-request-illustration.jpg?fmt=webp&w=300"
            type="image/webp"
            media="(max-width: 992px)"
          />

          <source
            srcset="https://cdn.vexels.com/img/design-request-illustration.jpg?fmt=webp"
            type="image/webp"
          />

          <source
            srcset="https://cdn.vexels.com/img/design-request-illustration.jpg"
            type="image/jpeg"
          />

          <img
            class="img-fluid"
            src="https://cdn.vexels.com/img/design-request-illustration.jpg"
            :alt="altImage"
            height="400"
            width="710"
            loading="lazy"
          />
        </picture>
      </b-col>
      <b-col class="d-none d-md-block" cols="2"></b-col>
    </b-row>
    <b-row>
      <h2 class="text mt-4">
        {{ description }}
      </h2>
    </b-row>
    <b-row class="text">
      <Button shape="outline" color="white" text="gray" hover="exp" :to="requestLink">
        {{ requestText }}
      </Button>
    </b-row>
  </b-container>
</template>

<script>
import Button from 'UI/Button';
export default {
  components: {
    Button
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    altImage: {
      type: String,
      required: true
    },
    requestText: {
      type: String,
      required: true
    }
  },
  computed: {
    requestLink() {
      const link = this.$auth.loggedIn
        ? this.localePath('profile-my-requests-new')
        : this.$urlBuilder('landing', { uid: 'design-requests' });
      return link;
    }
  }
};
</script>

<style lang="scss" scoped>
.text {
  font-weight: 500;
  color: $strongGray;
  font-size: 1.8em;
  margin-bottom: 20px;
}
</style>
